import { Pipe, type PipeTransform } from '@angular/core';
import { AutomationTiming } from '@principle-theorem/principle-core';
import { type IAutomationTiming } from '@principle-theorem/principle-core/interfaces';

@Pipe({
  name: 'prTimingDisplay',
})
export class TimingDisplayPipe implements PipeTransform {
  transform(timing: IAutomationTiming): string {
    return AutomationTiming.getTimingSummary(timing);
  }
}
